// extracted by mini-css-extract-plugin
module.exports = {"with-shadow":"Calendar_with-shadow__1hwmO","disabledChange":"Calendar_disabledChange__n0UAY","custom-calendar":"Calendar_custom-calendar__2QO73"};